const state = {
    show: false,
    alarmId: sessionStorage.getItem('groupId'),
    pathList:[],
    pendingCount: 0,
    processingCount: 0,
    notCompare:{}, //应急联动对话组
    notGroupMember:{}, //IM对话组
	hasNewAlarm:false,//是否有新的报警
	isForbidden:false,//是否禁用消息发送
	visionGroupId:'',//已上报/已参与的groupId
	
	// 会议
	currentMeetingInfo:'',//收到消息的内容
	meetingId:'',//当前处理的meetingId
	
	
    message:{},//消息对话组
    configMenuList:localStorage.getItem('menuSettings')?JSON.parse(localStorage.getItem('menuSettings')):[],
	isHome:false,//判断是否重新创建IM
	isBreakIM:false,//判断是否退出登录，退出后不再重连IM
    isIm:false,//IM是否断开
    
    // 消息铃铛
    msgBell:[],
      // 顶部切换tab
    visitedViews: [],
    cachedViews: [],

    // 
    headActiveIndex: "", // 头部菜单index
    leftMenuList: [], // 左边菜单
    leftActiveIndex: "", // 左边菜单index
}

export default state
